const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function safePathFromUrl(urlLike) {
  if (!urlLike) return '';
  try {
    const parsed = new URL(urlLike, window.location.origin);
    return `${parsed.pathname}${parsed.search || ''}`;
  } catch {
    return String(urlLike);
  }
}

export function sendConversionEvent(payload) {
  const body = {
    event_type: payload.event_type,
    event_name: payload.event_name,
    route: payload.route || window.location.pathname,
    destination: safePathFromUrl(payload.destination || ''),
    label: payload.label || '',
    context: payload.context || {},
  };

  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', body.event_name, {
      event_category: body.event_type,
      event_label: body.label || body.destination || body.route,
      route: body.route,
      destination: body.destination,
    });
  }

  if (typeof window !== 'undefined' && Array.isArray(window.dataLayer)) {
    window.dataLayer.push({
      event: body.event_name,
      event_type: body.event_type,
      route: body.route,
      destination: body.destination,
      label: body.label,
    });
  }

  if (!BACKEND_URL) return;

  const endpoint = `${BACKEND_URL}/api/analytics/events`;
  const jsonBody = JSON.stringify(body);

  try {
    if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
      const blob = new Blob([jsonBody], { type: 'application/json' });
      navigator.sendBeacon(endpoint, blob);
      return;
    }
  } catch {
    // fallback below
  }

  fetch(endpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: jsonBody,
    keepalive: true,
  }).catch(() => {
    // silent by design
  });
}
